export const NEXT_LINK = 'x-link-next';
